<template>
  <div class="main" v-redirect-if-no-permission:ZONES>
    <v-form ref="form" style="max-height: 118px">
      <v-container>
        <div class="title text--primary">
          {{ $t("zonesPage.editorTitle") }}
        </div>
        <v-layout>
          <v-flex md2 sm12>
            <v-text-field v-model="data.name" append-icon="edit" :label="$t('zonesPage.name')" :rules="[rules.required]" single-line
              hide-details></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>


          <v-spacer></v-spacer>
          <!-- <v-flex md3 sm12 style="display: flex; align-items: center"> -->
          <!-- <div class="check-box" style="padding: 5%;"> -->
          <!-- <input type="checkbox" v-model="data.blacklisted" style="margin: 4px"/> -->
          <!-- <label -->
          <!-- class="noselect" -->
          <!-- @click="data.blacklisted = !data.blacklisted" -->
          <!-- >Mark this sector as a blacklist</label -->
          <!-- > -->
          <!-- </div> -->
          <!-- </v-flex> -->
          <!-- <v-flex md3 sm12>
            <v-text-field
              v-model="data.radius"
              append-icon="place"
              label="Radius"
              :rules="[rules.required, rules.number]"
              single-line
              hide-details
            ></v-text-field>
          </v-flex> -->
          <v-spacer></v-spacer>
          <v-flex md1>
            <v-btn color="primary" dark class="mb-2" @click.stop="dialog = true">{{ $t("zonesPage.save") }}</v-btn>
          </v-flex>

          <v-dialog v-model="dialog" max-width="290">
            <v-card>
              <v-card-title class="headline">{{ $t("zonesPage.saveChangesQuestion") }}</v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary" flat="flat" @click="dialog = false">
                  {{ $t("zonesPage.cancel") }}
                </v-btn>

                <v-btn color="primary" flat="flat" @click="save"> {{ $t("zonesPage.save") }} </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="diaload" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                {{ $t("zonesPage.savingChanges") }}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-form>
    <div id="map"></div>
  </div>
</template>
<script>
import Mapbox from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import centroid from "@turf/centroid";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

export default {
  name: "ZonesEditor",
  title() {
    return this.$t("zonesPage.editorPageTitle");
  },

  data() {
    return {
      baseUri: "location-cluster",
      mode: "add", // or edit
      id: null,
      map: null,
      diaload: false,
      loading: false,
      dialog: false,
      drawComponent: null,
      answer: null,
      center: null,
      centroid: null,
      polygon: null,
      data: {
        name: null,
        centroid: null,
      },
    };
  },
  mounted() {
    Mapbox.accessToken = this.api.mapBox.accessToken;
    this.center = this.api.mapBox.center;
    if (this.$route.params.id !== undefined) {
      this.mode = "edit";
      this.id = this.$route.params.id;
      this.getData();
    } else {
      this.mode = "add";
      this.loadMap();
    }
  },
  methods: {
    inside(point, vs) {
      // ray-casting algorithm based on
      // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

      var x = point[0],
        y = point[1];

      var inside = false;
      for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i][0],
          yi = vs[i][1];
        var xj = vs[j][0],
          yj = vs[j][1];

        var intersect =
          yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }

      return inside;
    },
    loadMap() {
      this.map = new Mapbox.Map(
        Object.assign({ container: "map" }, this.api.mapBox, {
          center: this.center,
        })
      );
      this.drawComponent = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true,
        },
        styles: [
          // Inactive polygon fill (when not selected)
          {
            id: "gl-draw-polygon-fill-inactive",
            type: "fill",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Polygon"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "fill-color": "#4CAF50", // Green fill
              "fill-opacity": 0.3,
            },
          },
          // Active polygon fill (when selected)
          {
            id: "gl-draw-polygon-fill-active",
            type: "fill",
            filter: [
              "all",
              ["==", "active", "true"],
              ["==", "$type", "Polygon"],
            ],
            paint: {
              "fill-color": "#4CAF50", // Green fill
              "fill-outline-color": "#4CAF50",
              "fill-opacity": 0.2,
            },
          },
          // Inactive polygon stroke (border when not selected)
          {
            id: "gl-draw-polygon-stroke-inactive",
            type: "line",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Polygon"],
              ["!=", "mode", "static"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#4CAF50", // Green border
              "line-width": 2,
            },
          },
          // Active polygon stroke (border when selected)
          {
            id: "gl-draw-polygon-stroke-active",
            type: "line",
            filter: [
              "all",
              ["==", "active", "true"],
              ["==", "$type", "Polygon"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#4CAF50", // Green border
              "line-dasharray": [0.2, 2],
              "line-width": 2,
            },
          },
          // Polygon midpoint (for editing)
          {
            id: "gl-draw-polygon-midpoint",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["==", "meta", "midpoint"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#fbb03b",
            },
          },
          // Vertex stroke (outline of edit points)
          {
            id: "gl-draw-polygon-and-line-vertex-stroke-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "meta", "vertex"],
              ["==", "$type", "Point"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-color": "#fff",
            },
          },
          // Vertex fill (edit points)
          {
            id: "gl-draw-polygon-and-line-vertex-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "meta", "vertex"],
              ["==", "$type", "Point"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#fbb03b",
            },
          },
          // Active vertex stroke
          {
            id: "gl-draw-point-stroke-active",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["==", "active", "true"],
              ["!=", "meta", "midpoint"],
            ],
            paint: {
              "circle-radius": 7,
              "circle-color": "#fff",
            },
          },
          // Active vertex fill
          {
            id: "gl-draw-point-active",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["!=", "meta", "midpoint"],
              ["==", "active", "true"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-color": "#fbb03b",
            },
          },
        ],
      });

      this.map.addControl(this.drawComponent);
      this.map.on("draw.create", this.updateArea);
      this.map.on("draw.delete", this.updateArea);
      this.map.on("draw.update", this.updateArea);
      //   this.center = this.api.mapBox.center;
      this.marker = new Mapbox.Marker({ draggable: true });
      this.marker.setLngLat(this.data.centroid);
      this.marker.addTo(this.map);
    },
    getData() {
      this.axios.get(this.baseUri + `/${this.id}`).then(({ data }) => {
        console.log('data', data.data);

        const { name, polygon } = data.data;
        this.center = centroid(polygon).geometry.coordinates;
        this.data.centroid = data.data.centroid ? data.data.centroid.coordinates : this.center;
        this.polygon = data.data.polygon.coordinates[0];
        this.loadMap();
        this.drawComponent.add(polygon);
        this.data.name = name;
      });
    },
    updateArea(e) {
      if (e.type === "draw.create") {
        this.drawComponent.deleteAll();
        this.drawComponent.add(e.features[0]);
      }
    },
    reset() {
      this.drawComponent.deleteAll();
      this.data.name = null;
    },
    save() {
      if (this.mode == "edit") {
        // console.log("edit");
        this.data.centroid = {
          type: "Point",
          coordinates: this.marker.getLngLat().toArray(),
        };

        const polygons = this.drawComponent.getAll().features;
        if (!this.loading && this.$refs.form.validate()) {
          if (polygons.length === 0) {
            alert(this.$t("zonesPage.choosePolygon"));
            return;
          }
          if (this.inside(this.data.centroid.coordinates, this.polygon)) {
            this.loading = true;
            this.diaload = true;
            this.dialog = false;

            const polygon = polygons[0].geometry;

            const url =
              this.mode === "add" ? this.baseUri : this.baseUri + "/" + this.id;
            (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
              polygon,
              ...this.data,
            })
              .then(() => {
                window.getApp.$emit("SHOW_TOAST", this.$t("zonesPage.saved"), "green");
                this.mode === "add" ? this.reset() : null;
              })
              .catch(() =>
                window.getApp.$emit("SHOW_TOAST", this.$t("zonesPage.notSaved"), "red")
              )
              .finally(() => {
                this.loading = false;
                this.diaload = false;
              });
          } else
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("zonesPage.centroidInside"),
              "red"
            );
        }
      }

      if (this.mode == "add") {
        const polygons = this.drawComponent.getAll().features;
        if (!this.loading && this.$refs.form.validate()) {
          if (polygons.length === 0) {
            alert(this.$t("zonesPage.choosePolygon"));
            return;
          }
          this.loading = true;
          this.diaload = true;
          this.dialog = false;

          const polygon = polygons[0].geometry;
          if (!this.data.centroid)
            this.data.centroid = {
              type: "Point",
              coordinates: centroid(polygon).geometry.coordinates
            }
          const url =
            this.mode === "add" ? this.baseUri : this.baseUri + "/" + this.id;
          (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
            polygon,
            ...this.data,
          })
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("zonesPage.saved"), "green");
              this.mode === "add" ? this.reset() : null;
            })
            .catch(() => window.getApp.$emit("SHOW_TOAST", this.$t("zonesPage.notSaved"), "red"))
            .finally(() => {
              this.loading = false;
              this.diaload = false;
            });
        }
      }
    },
  },
  computed: {
    rules() {
      return {
        required: (value) => !!value || this.$t("zonesPage.required"),
        number: (value) => isFinite(value) || this.$t("zonesPage.mustBeNumber"),
      };
    },
  },
};
</script>

<style scoped>
#map {
  width: 100%;
  height: calc(100vh - 64px - 118px);
}
</style>
